import { createContext, useContext } from 'react';
import { useInteractions } from '@floating-ui/react';
import { assertNotNil } from '../../../utils/types';

export interface ISingleSelectContext {
  getItemProps: ReturnType<typeof useInteractions>['getItemProps'];
  handleSelect: (index: number | null) => void;
  activeIndex: number | null;
}

export const SingleSelectContext = createContext<ISingleSelectContext | null>(
  null,
);

export const useSingleSelectContext = () => {
  const context = useContext(SingleSelectContext);
  assertNotNil(context);
  return context;
};
